"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCategoryData = exports.getCategoryTypesObject = void 0;
var _objectSpread2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _react = _interopRequireDefault(require("react"));
var _EmailBox = require("../email-box/EmailBox");
var getCategoryTypesObject = function getCategoryTypesObject(categories) {
  return {
    primaryCategories: categories.filter(function (cat) {
      return cat.level === 'primary';
    }),
    secondaryCategories: categories.filter(function (cat) {
      return cat.level === 'secondary';
    }),
    tabletCategories: categories.filter(function (cat) {
      return cat.level === 'tablet';
    }),
    mobileCategories: categories.filter(function (cat) {
      return cat.level === 'mobile';
    })
  };
};
exports.getCategoryTypesObject = getCategoryTypesObject;
var setCategoryData = function setCategoryData(categories, _ref) {
  var tasksCount = _ref.tasksCount,
    invoicesCount = _ref.invoicesCount,
    traderSlug = _ref.traderSlug;
  var EmailBoxComponent = function EmailBoxComponent() {
    return /*#__PURE__*/_react.default.createElement(_EmailBox.EmailBox, {
      traderSlug: traderSlug
    });
  };
  var getNotificationCountForCategory = function getNotificationCountForCategory(categoryId) {
    switch (categoryId) {
      case 'tasks':
        return tasksCount || null;
      case 'invoices':
        return invoicesCount || null;
      default:
        return null;
    }
  };
  return categories.map(function (category) {
    return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, category), {}, {
      notificationCount: getNotificationCountForCategory(category.id),
      CustomComponent: category.id === 'email' ? EmailBoxComponent : null
    });
  });
};
exports.setCategoryData = setCategoryData;